import { main as axios } from "../axios";
import hostConfig from "@/config/hostResolver";

const baseUrl = `${
  process.env.VUE_APP_INTEGRATION_URL ?? hostConfig.apiBaseUrl
}/integration-service/v3/prismatic/token`;

class PrismaticTokenService {
  async getJwtToken() {
    const response = await axios.get(`${baseUrl}`);
    return response.data.result;
  }
}

export default new PrismaticTokenService();
